
export const AMAPI_UsbDataAccess_Enums = {
    usbDataAccessUnspecified:   "USB_DATA_ACCESS_UNSPECIFIED",   // 未指定
    allowUsbDataTransfer:       "ALLOW_USB_DATA_TRANSFER",       // 許可
    disAllowUsbFileTransfer:    "DISALLOW_USB_FILE_TRANSFER",    // 禁止(弱)
    disAllowUsbDataTransfer:    "DISALLOW_USB_DATA_TRANSFER"     // 禁止(強)
}
export type AMAPI_UsbDataAccessState = typeof AMAPI_UsbDataAccess_Enums[keyof typeof AMAPI_UsbDataAccess_Enums]

export const AMAPI_ConfigureWifi_Enums = {
    configureWifiUnspecified:   "CONFIGURE_WIFI_UNSPECIFIED",   // 未指定
    allowConfiguringWifi:       "ALLOW_CONFIGURING_WIFI",       // 許可
    disAllowAddWifiConfig:      "DISALLOW_ADD_WIFI_CONFIG",     // 禁止(弱)
    disallowConfiguringWifi:    "DISALLOW_CONFIGURING_WIFI"     // 禁止(強)
}
export type AMAPI_ConfigureWifiState = typeof AMAPI_ConfigureWifi_Enums[keyof typeof AMAPI_ConfigureWifi_Enums]